import { __rest } from '../../_virtual/_tslib.js';
import { PortalHeaderWrapper } from '@lsg/shared';
import { createElement } from 'react';

var defaultProps = {};

var PortalHeader = function PortalHeader(_a) {
  var props = __rest(_a, []); // backup for logoAttrs as long as prop is deprecated but not deleted


  var logoHtmlAttrs = props.logoHtmlAttrs,
      logoAttrs = props.logoAttrs,
      restProps = __rest(props, ["logoHtmlAttrs", "logoAttrs"]);

  return /*#__PURE__*/createElement(PortalHeaderWrapper, Object.assign({
    logoHtmlAttrs: logoHtmlAttrs || logoAttrs
  }, restProps));
};

PortalHeader.displayName = "PortalHeader";
PortalHeader.defaultProps = defaultProps;

export { PortalHeader };
